const cache = {};

export const loadMarkdown = async (page, lang, content) => {
    try {
        const key = `${page}-${lang}-${content}`;
        if (cache[key]) return cache[key];

        const mdPath = require(`../assets/content/${page}/${lang}/${content}.md`);
        const response = await fetch(mdPath);
        const text = await response.text();
        cache[key] = text;
        return text;
    } catch (err) {
        console.warn(`Markdown non trovato per ${page}/${lang}/${content}`, err);
        return "Contenuto non disponibile";
    }
};